export default {
  name : "z-map-ui",
  map : null,
  setMap(map){
    this.map=map
  },
  getMap(){
    return this.map
  }
}




// WEBPACK FOOTER //
// ./src/components/zmapConfig.js